export default __webpack_public_path__ + "static/media/para-05.635fefd3.jpg";